import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cancel-application',
  templateUrl: './cancel-application.component.html',
  styleUrls: ['./cancel-application.component.scss']
})
export class CancelApplicationComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/Source/Ecim/Ecim.Web/src/app/components/cancel-application/cancel-application.component.ts